export const specialsValues = ['סט', 'קנה קבל', 'קנה קבל מרכז'] as const;
export const typeOfSpecials = specialsValues.map((value, index) => ({ text: value, value: index }));
export const specialsTypesEnum = {
	NORMAL: 0,
	BUY_GET: 1, // need to add functionality
	BUY_GET_MAIN_PRODUCT: 2,
	// no 3
	FATHER_SON: 4,
} as const;

export type Special = {
	ID: number;
	SpecialID: number;
	Name: string;
	StartDate: Date;
	EndDate: Date;
	SpecialStatus: 0 | 1 | 2;
	ProductID: string;
	Client_Id: string;
	Stock: number;
	Company: number;
	TeudaPackQuantity: number;
	TeudaQuantity: number;
	TeudaBonusQuantity: number;
	TeudaItemNetPrice: number;
	MaxInCart: number;
	SpecialType: typeof specialsTypesEnum[keyof typeof specialsTypesEnum];
	PriceCode: string;
	SpecialExtra1: string;
	SpecialExtra2: string;
	SpecialDescription: string;
	length?: number;
	Color?: string;
	BonusType?: SpecialBonusType;
	ItemPack?: number;
	Product_Name?: string;
};

export interface specialPostBody extends specialPatchBodyEdit {
	StartDate: Date;

	EndDate: Date;

	ProductID: string;

	Client_Id: string;

	Company: number;

	Stock: number;

	TeudaQuantity: number;

	TeudaPackQuantity: number;

	TeudaBonusQuantity: number;

	TeudaItemNetPrice: number;

	// PriceCode: number;
	MaxInCart: number;
	Name: string;
	BonusType?: SpecialBonusType;
}

export type SpecialsEditBodyDelete = {
	mode: 'delete';
	ID: number;
};

export type SpecialsEditBodyEditOrCreate = {
	mode: 'update' | 'create';
	ID: number;
	SpecialID: number;
	StartDate: Date;
	EndDate: Date;
	Name: string;
	ProductID: string;
	Stock: number;
	Client_Id: string;
	Company: number;
	TeudaQuantity: number;
	TeudaPackQuantity: number;
	TeudaBonusQuantity: number;
	TeudaItemNetPrice: number;
	SpecialStatus: Special['SpecialStatus'];
	MaxInCart: number;
	SpecialType: Special['SpecialType'];
	Color: string;
	SpecialDescription: string;
	BonusType: Special['BonusType'];
};

export type SpecialsEditBody = SpecialsEditBodyDelete | SpecialsEditBodyEditOrCreate;

export type SpecialBonusType = 'single' | 'packs';

export interface specialPatchBodyEdit {
	SpecialID: number;
	SpecialStatus: Special['SpecialStatus'];
}

export type SpecialObjectHash<T> = {
	[ID: number | string]: T;
};

export type SpecialInCartObj = {
	[key: string]: SpecialInCart;
};

export type SpecialInCart = {
	special: Special[];
	quantity: number;
	quantitiesDifferentButNotSavedYet?: boolean;
};

export type SpecialsFather = {
	ID: number;
	SpecialID: number;
	Line: number | null;
	ProductId: string;
	ProductName: string | null;
	Price: number | null;
	Quantity: number | null;
	Extra: string | null;
	Extra2: string | null;
	Color: string | null;
	FStatus: string | null;
	Weight?: number;
};

export type SpecialsFatherWithState = SpecialsFather & { isReadyToBeAdded: boolean; cantInteract: boolean; ItemNetPrice: number };

export type SpecialsSon = {
	ID: number;
	FatherID: number;
	ProductId: string | null;
	ProductName: string | null;
	Quantity: number | null;
	Limit: number | null;
	Extra: string | null;
	Extra2: string | null;
	Color: string | null;
	SStatus: string | null;
	Weight?: number;
	Type?: number;
	weightMode?: 'weight' | 'singles';
	packsWeightMode?: 'boxes' | 'packs';
	originalItemPack?: number;
};

export type SpecialsSonWithState = SpecialsSon & {
	ItemPack?: number;
	TeudaQuantity?: number;
	TeudaPackQuantity?: number;
	Stock?: number;
	BS?: number;
	qt?: number;
	isDisabled: boolean;
	hidePacks?: boolean;
	hideSingles?: boolean;
	ItemNetPrice?: number;
	previousTeudaQuantity?: number;
	previousTeudaPackQuantity?: number;
	isFather?: boolean;
	ItemExtra5?: string | number;
};

export type SpecialsFatherSon = {
	father: SpecialsFather;
	son: SpecialsSon[];
};

export type SpecialsFatherSonObj = {
	[fatherID: string]: SpecialsFatherSon;
};
